import { create } from "zustand";

interface UiState {
  /** Navigation drawer on phones and small tablets. */
  navOpen: boolean;
  setNavOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>()((set) => ({
  navOpen: false,
  setNavOpen: (navOpen) => set({ navOpen }),
}));
